import React from 'react';
import { Link } from 'react-router-dom';

/**
 * PrivacyPolicy - Minimal, GDPR-compliant
 */
function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-4 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <p className="text-sm text-gray-500">Last updated: December 18, 2025</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8 space-y-6 text-gray-700 text-sm leading-relaxed">

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">What We Collect</h2>
            <ul className="space-y-2">
              <li><strong>Account:</strong> Email address and encrypted password</li>
              <li><strong>Usage:</strong> Prompts, model selections, comparison results</li>
              <li><strong>Technical:</strong> IP address, browser type (for security)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">How We Use It</h2>
            <ul className="space-y-2">
              <li>• Provide and improve our AI comparison service</li>
              <li>• Send important service updates</li>
              <li>• Analyze usage to improve features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Data Sharing</h2>
            <p className="mb-2">We don't sell your data. We share only with:</p>
            <ul className="space-y-1">
              <li>• <strong>AI Providers</strong> - to process your prompts</li>
              <li>• <strong>Legal authorities</strong> - if required by law</li>
            </ul>
          </section>

          <section className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Your Rights (GDPR)</h2>
            <ul className="space-y-1">
              <li>✓ <strong>Access</strong> - Download your data anytime</li>
              <li>✓ <strong>Delete</strong> - Request account deletion</li>
              <li>✓ <strong>Portability</strong> - Export your data (JSON/CSV)</li>
              <li>✓ <strong>Opt-out</strong> - Control marketing emails</li>
            </ul>
            <p className="mt-3 text-xs text-gray-600">
              Manage your data in <Link to="/profile" className="text-blue-600 hover:underline">Profile Settings</Link> or email info@midolabs.ai
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Security</h2>
            <p>All data is encrypted in transit (HTTPS) and at rest. Passwords are hashed with bcrypt.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Cookies</h2>
            <p>We use essential cookies for authentication. Optional analytics cookies require your consent.</p>
          </section>

        </div>

        {/* Footer Links */}
        <div className="mt-6 text-center text-sm text-gray-500">
          <Link to="/terms" className="hover:text-blue-600">Terms</Link>
          <span className="mx-2">•</span>
          <Link to="/" className="hover:text-blue-600">Home</Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;